import { MyEnergiBaseColour } from "_core/types/charger";
import {
  PRICE_ZAPPI_21_SOCKET,
  PRICE_ZAPPI_21_TETHERED,
} from "_core/config/prices";
import { CableSetup } from "_core/types";

export const ZAPPI_21_CABLE_SETUP: {
  value: CableSetup;
  label: string;
  price: number;
}[] = [
  {
    label: "Untethered",
    price: PRICE_ZAPPI_21_SOCKET,
    value: CableSetup.UNTETHERED,
  },
  {
    label: "Tethered",
    price: PRICE_ZAPPI_21_TETHERED,
    value: CableSetup.TETHERED,
  },
];

export const ZAPPI_21_COLOURS: {
  value: MyEnergiBaseColour;
  label: string;
}[] = [
  {
    value: "Black",
    label: "Black",
  },
  {
    value: "White",
    label: "White",
  },
];
